const SALUTATIONS = ["Mr", "Mrs", "Ms", "M/S"];

// Legacy records store only `customer_name` ("Mrs Roshni Khemka") with no
// first/last split. Rebuild the split, dropping a leading salutation token.
export const splitCustomerName = (customerName) => {
  const parts = (customerName || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length && SALUTATIONS.some((s) => s.toLowerCase() === parts[0].toLowerCase())) {
    parts.shift();
  }
  return { first_name: parts[0] || "", last_name: parts.slice(1).join(" ") };
};

// Use the stored split when present, otherwise derive it from customer_name.
export const resolveCustomerNames = (record) => {
  const first = record?.first_name || "";
  const last = record?.last_name || "";
  if (first || last) return { first_name: first, last_name: last };
  return splitCustomerName(record?.customer_name);
};
